import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  closeDispenserUserSnackBar, setConfigFilteredDispenserUser, setConfigPageDispenserUser,
  setConfigPageSizeDispenserUser, setConfigSortedDispenserUser, setDispenserUserFilters,
  setDispenserUserSnackBar,  
} from "../../redux/actions/dispenserUser/dispenserUserAction";

export const useTableDispenserUserConfig = () => {
  const dispatch = useDispatch();
  
  const handleFilter = useCallback((e) => {
    dispatch(setConfigFilteredDispenserUser(e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(setConfigSortedDispenserUser(e));
  }, []);

  const setSnackBar = useCallback((msg) => {
    dispatch(setDispenserUserSnackBar(msg));
  }, []);

  const clearSnackBar = useCallback(() => {
    dispatch(closeDispenserUserSnackBar());
  }, []);

  const handlePage = useCallback((e) => {
    dispatch(setConfigPageDispenserUser(e));
  }, []);

  const handlePageSize = useCallback((e) => {
    dispatch(setConfigPageSizeDispenserUser(e));
  }, []);

  const handleInputs = useCallback(({ target }) => {
    dispatch(setDispenserUserFilters(target.name, target.value));
  }, [])

  const handleChangeYear = useCallback((e, v) => {
    dispatch(setDispenserUserFilters('year', v ? v : null));
  }, []);

  const handleChangeMonth = useCallback((e, v) => {
    dispatch(setDispenserUserFilters('month', v ? v : null));
  }, []);

  const handleChangeStation = useCallback((e, v) => {
    dispatch(setDispenserUserFilters('station', v ? v : null));
  }, []);

  const handleChangeUnitOptions = useCallback((v = []) => {
    dispatch(setDispenserUserFilters('unitOptions', v));
  }, []);

  const handleChangeUnit = useCallback((e, v) => {
    dispatch(setDispenserUserFilters('unit', v ? v : null));
  }, []);

  return {
    setSnackBar, clearSnackBar, handleInputs, handleFilter, handleSort, handlePage, handlePageSize, 
    handleChangeYear, handleChangeMonth, handleChangeStation, handleChangeUnitOptions, handleChangeUnit
  };
};